import styled from "styled-components";
import { isMobile } from "react-device-detect";

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 3vh;
  flex-wrap: wrap;
  flex-direction: row-reverse;
`;

export const Option = styled.div`
  cursor: pointer;
  background: ${(props) =>
    props.backgroundColor ? props.backgroundColor : "#5776ff"};
  color: ${(props) => (props.textColor ? props.textColor : "white")};
  border: 1px solid ${(props) => (props.borderColor ? props.borderColor : "")};
  border-radius: 15vh;
  height: 15vh;
  flex: 0 48%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3.1vh;
  font-size: 5.714285714285714vh;
  text-align: center;
  font-weight: bold;

  &:hover {
    background: ${!isMobile
      ? (props) =>
          props.backgroundHoverColor ? props.backgroundHoverColor : "#3F5ED1"
      : ""};
  }

  &:active {
    background: ${(props) =>
      props.backgroundHoverColor ? props.backgroundHoverColor : "#3F5ED1"};
  }

  &:visited {
    background: ${(props) =>
      props.backgroundColor ? props.backgroundColor : "#5776ff"};
  }
`;
